export const CPF_VISIBLE_COUNTRY = 'BR';
export const RUT_VISIBLE_COUNTRY = 'CL';

export enum ECpfCheckMethod {
  BY_COUNTRY = 'byCountry',
  BY_PAY_BROKER = 'byPayBroker',
  BY_LEGITIMUZ = 'byLegitimuz',
  NONE = 'none'
}
